import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

const reserveBtn = document.querySelector('#reserve');

if (reserveBtn) {
    reserveBtn.addEventListener("click", membership);
}

$(function(){
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $(".top-wrap").addClass("active");
        } else {
            $(".top-wrap").removeClass("active");
        }
    });
    
    // 탑메뉴 스크롤
    $('.top-menu li > a').click(function (){
        $('html, body').animate({scrollTop: $(this.hash).offset().top - $('.top-wrap').outerHeight() + 1}, 600);
    });

    $('.tel').on("keyup",function() {
        const prev    = $(this).val();
        const str     = prev.replace(/[^0-9]/g, "").replace(/(^02|^0505|^01.{1}|^0[0-9]{2})([0-9]+)?([0-9]{4})/,"$1-$2-$3").replace("--", "-");
        $(this).val(str);
    });
    
    $(".info-popup .tab-wrap >li").click((e) => {
        $('.info-popup .tabCont >li').hide()
        $('.info-popup .tabCont >li').eq($(e.currentTarget).index()).show()
    })
    
    $(".info-popup .fold-wrap h5").click((e) => {
        $(e.currentTarget).siblings('.fold').toggle()
    })

    const PopupModule = {
        // 팝업 초기화
        initPopup(popupId, nextId) {
            const today = moment().format('YYYY-MM-DD');
            const closedDate = localStorage.getItem(`closedDate_${popupId}`);
            
            closedDate !== today 
            ? $(`.${popupId}`).show() 
            : nextId && $(`.${nextId}`).show();
            
            $('.todayClosed').click(() => {
                localStorage.setItem(`closedDate_${popupId}`, today);
                $(`.${popupId}`).hide();
            });

        },
    
        // 모든 팝업 초기화
        init() {
            const closeBtn = $('.todayClosed')

            if (closeBtn.length === 0) return;

            closeBtn.each((_, popup) => {
                const popupId = $(popup).data('popup');
                const nextId = $(popup).data('next')
                this.initPopup(popupId, nextId );
            });
        }
      };
      
    PopupModule.init()
  
});